import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './main.css';

import plant from './images/Section 7-plant.svg';
import person from './images/Section 7 - Person.svg';

function Section7() {
    AOS.init();
    return (
        <section className="australia-council-section7">
            <div className="ac-section7-paragraph">
                <div className="ac-section7-image-container">
                    <img src={plant} height="350px" alt="" className="ac-section7-image-plant" />
                    <img src={person} height="500px" alt="" className="ac-section7-image-person" />
                </div>
            </div>

            <div className="ac-section7-paragraph1">
                <h2 data-aos="fade-down" data-aos-delay="100" data-aos-duration="2000" data-aos-once="true">Here are Some of The Ways that Your
                Council can benefit from Ziplyne</h2>
                <div className="ac-section7-paragraph1-inner">
                    <div className="ac-section7-paragraph1-col">
                        <p data-aos="fade-down" data-aos-delay="300" data-aos-duration="1500" data-aos-once="true" >Guidance and navigation for both <br />
                    regular and first-time users whether <br />
                        they be individuals or institutions</p>

                        <p data-aos="fade-down" data-aos-delay="900" data-aos-duration="1500" data-aos-once="true">Tooltips to demonstrate best practices <br />
                        and offer data explanation </p>

                        <p data-aos="fade-down" data-aos-delay="1600" data-aos-duration="1500" data-aos-once="true">Unlocking hidden value that might be <br />
                    overlooked by a first-time user</p>
                    </div>

                    <div className="ac-section7-paragraph1-col">
                        <p data-aos="fade-down" data-aos-delay="600" data-aos-duration="1500" data-aos-once="true" >Reduction of support tickets and<br />
                        lowering of support demands for <br />
                        you and your team <br /></p>

                        <p data-aos="fade-down" data-aos-delay="1200" data-aos-duration="1500" data-aos-once="true">Highlighting and explanation of new features as<br />
                        they are rolled out, negating the need for blast<br />
                        emails, pdfs, and video tutorials<br /></p>

                        <p data-aos="fade-down" data-aos-delay="1800" data-aos-duration="1500" data-aos-once="true">Overall augmentation of UX (User Experience) <br />
                        and reduction of data errors <br />
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Section7
